import React from "react";
import { X } from "react-bootstrap-icons";

interface PuzzleFeedOnboardingCardProps {
    onClose: () => void;
    onOpenHelp: () => void;
}

const PuzzleFeedOnboardingCard: React.FC<PuzzleFeedOnboardingCardProps> = ({ onClose, onOpenHelp }) => {
    return (
        <section className="tw-mb-4 tw-overflow-hidden tw-rounded-[10px] tw-bg-[#24093e] tw-px-6 tw-py-6 md:tw-px-9 md:tw-py-8">
            <div className="tw-relative">
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Dismiss onboarding"
                    className="tw-bg-[#24093e] tw-p-0 tw-absolute tw-right-[-15px] tw-top-[-15px] tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-sm tw-text-[#A89CB8] hover:tw-text-white"
                >
                    <X size={18} />
                </button>

                <p className="tw-mb-2 tw-pr-12 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-[#f97316]">
                    Welcome to PriceMe
                </p>
                <h2 className="tw-mb-[10px] tw-font-merriweather tw-text-[22px] tw-font-bold tw-leading-[1.25] tw-text-white">
                    This is your feed.
                </h2>
                <p className="tw-mb-[14px] tw-max-w-[980px] tw-text-[14px] tw-font-normal tw-leading-[1.55] tw-text-[#d8d4e0]">
                    Scroll through homes, tap to guess the price, and follow agents whose listings you love.
                </p>

                <button
                    type="button"
                    onClick={onOpenHelp}
                    className="tw-inline-flex tw-items-center tw-bg-transparent tw-p-0 tw-text-[14px] tw-font-semibold tw-leading-none tw-text-[#f97316] hover:tw-text-[#fb923c]"
                >
                    How to play <span aria-hidden="true">→</span>
                </button>
            </div>
        </section>
    );
};

export default PuzzleFeedOnboardingCard;
